module.exports = __webpack_public_path__ + "img/default_head@2x.19944b29.png";